export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '____OF_SECTIONS': '# of Sections',
    '____OF_QUESTIONS': '# of Questions',
    '__RECOMMENDED': 'Recommended',
    '_11346_SECTIONS': 'Sections',
    '_11347_QUESTIONS': 'Questions',
    '_11352_WHY_THIS_GUIDE': 'Why this guide?'
};
